import { render, staticRenderFns } from "./test2.vue?vue&type=template&id=fe19ec0e&scoped=true&"
import script from "./test2.vue?vue&type=script&lang=js&"
export * from "./test2.vue?vue&type=script&lang=js&"
import style0 from "./test2.vue?vue&type=style&index=0&id=fe19ec0e&prod&lang=scss&scoped=true&"
import style1 from "./test2.vue?vue&type=style&index=1&id=fe19ec0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe19ec0e",
  null
  
)

export default component.exports